import { render, staticRenderFns } from "./RoomBranding.vue?vue&type=template&id=8e17c684&scoped=true&"
import script from "./RoomBranding.vue?vue&type=script&lang=js&"
export * from "./RoomBranding.vue?vue&type=script&lang=js&"
import style0 from "./RoomBranding.vue?vue&type=style&index=0&id=8e17c684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e17c684",
  null
  
)

export default component.exports